// extracted by mini-css-extract-plugin
export default {"zoomModal":"V3-z","image":"W3-z","button":"X3-z","isOverlayShown":"Y3-z"};